import * as React from 'react';
import Sticky from 'react-sticky-el';
import { rgba } from 'polished';
import styled from 'styled-components';

import { INTERNAL_LINKS, STICKY } from '../../utils';
import { Button, Heading } from '../design-system';

const StyledSticky = styled(Sticky)`
  > div {
    display: flex;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.borderColor.DEFAULT};
    background: ${({ theme }) => rgba(theme.backgroundColor, 0.5)};
  }

  .isSticky {
    margin: 100px 0;
  }
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 25px;
`;

const Margins = styled.div`
  padding: 40px;
`;
interface StickyCTAProps {
  disabled?: boolean;
  heading: string;
  label: string;
}

export const StickyCTA: React.ComponentType<StickyCTAProps> = React.memo(
  ({ heading, label, disabled = false }) => {
    return (
      <StyledSticky
        boundaryElement={`.${STICKY.Boundary}`}
        disabled={disabled}
        stickyClassName={STICKY.Element}
        stickyStyle={{ zIndex: 1 }}
        topOffset={-100}>
        <Margins>
          <StyledHeading renderAs="h4">{heading}</StyledHeading>
          <Button
            link={`${INTERNAL_LINKS.RequestADemo}?source=sticky-cta`}
            size="large"
            stylez="loud"
            text={label}
          />
        </Margins>
      </StyledSticky>
    );
  }
);
